import React from 'react';
import { Mail, ShieldAlert } from 'lucide-react';
import { SEOHead } from '@/components/seo/SEOHead';
import { getWithdrawnListing } from '@/utils/withdrawnListings';

export const WithdrawnListingNotice = ({ slug }) => {
  const notice = getWithdrawnListing(slug);

  if (!notice) {
    return null;
  }

  return (
    <>
      <SEOHead
        title={notice.title}
        description={notice.intro}
        robotsContent="noindex, nofollow, nosnippet"
        includeHreflang={false}
        canonicalUrl={null}
        includeCanonical={false}
        includeSocialMeta={false}
      />

      <section className="min-h-[70vh] bg-[radial-gradient(circle_at_top,_rgba(249,115,22,0.14),_transparent_32%),linear-gradient(180deg,_#fffaf5_0%,_#ffffff_48%,_#f8fafc_100%)] px-4 py-16">
        <div className="mx-auto max-w-4xl rounded-[2rem] border border-orange-100 bg-white/95 p-8 shadow-[0_24px_90px_rgba(15,23,42,0.08)] md:p-12">
          <div className="mb-6 flex items-center gap-3 text-orange-700">
            <span className="rounded-full bg-orange-100 p-3">
              <ShieldAlert className="h-5 w-5" />
            </span>
            <p className="text-xs font-semibold uppercase tracking-[0.28em]">Jigsaw Events Hub</p>
          </div>

          <h1 className="text-4xl font-bold text-slate-900 sm:text-5xl" data-testid="withdrawn-listing-title">{notice.title}</h1>
          <p className="mt-4 text-base leading-7 text-slate-600" data-testid="withdrawn-listing-intro">{notice.intro}</p>

          <div className="mt-8 space-y-7 text-[15px] leading-7 text-slate-700">
            {notice.sections.map((section) => (
              <section key={section.heading} className="border-t border-slate-200 pt-6">
                <h2 className="mb-3 text-sm font-semibold uppercase tracking-[0.16em] text-slate-900">{section.heading}</h2>
                <div className="space-y-3">
                  {section.body.map((paragraph) => (
                    <p key={paragraph} className="text-[15px] leading-7 text-slate-700">
                      {paragraph.includes('it@jigsawconferences.co.uk') ? (
                        <>
                          {paragraph.split('it@jigsawconferences.co.uk')[0]}
                          <a href="mailto:it@jigsawconferences.co.uk" className="font-medium text-orange-700 underline underline-offset-4">
                            it@jigsawconferences.co.uk
                          </a>
                          {paragraph.split('it@jigsawconferences.co.uk')[1]}
                        </>
                      ) : paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-orange-200 bg-orange-50 px-4 py-4 text-sm text-orange-900" data-testid="withdrawn-listing-status-note">
            <div className="flex items-start gap-3">
              <Mail className="mt-0.5 h-4 w-4 shrink-0" />
              <p>Listing removed • indexing blocked • no outbound event link available</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};